module.exports = __webpack_public_path__ + "img/__icon_WYWROTKA.ac8eb9c1.svg";